// extracted by mini-css-extract-plugin
module.exports = {"music":"Music_music__Di2Dr","buttons":"Music_buttons__qPVzE","musicLink":"Music_musicLink__1N5ml"};